export default {
  state: {
    detail: null,
    urlQuery: null,
    selectedPermList: null,
    permQueueIndex: 0
  },
  mutations: {
    setPermissionDetail(state, payload) {
      state.detail = payload
    },
    setPermissionPageQuery(state, payload) {
      state.urlQuery = payload
    },
    setPermQueue(state, payload) {
      state.selectedPermList = payload.list
      state.permQueueIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getPermissionDetail(state) {
      return state.detail
    },
    getPermissionPageQuery(state) {
      return state.urlQuery
    },
    getPermList(state) {
      return {
        list: state.selectedPermList,
        index: state.permQueueIndex
      }
    }
  }
}
